/* Adventskalender PLUS XXL – Deal-Produkt Fassung B: Veredelung, freie Stückzahl mit Staffel, Farb- (und Größen-)Aufteilung (Section sp-adv-deal-b) */
(function () {
  var el = document.querySelector('[data-spdl]');
  if (!el || el.dataset.ready) return;
  el.dataset.ready = '1';
  var EN = el.dataset.lang === 'en';
  function $(s) { return el.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function json(s) { try { return JSON.parse($(s).textContent); } catch (e) { return []; } }
  var variants = json('[data-spdl-variants]');
  var colors = json('[data-spdl-colordata]');
  var VAT = 1.19;
  function eur(c) { return (Math.round(c) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function num(n) { return n.toLocaleString('de-DE'); }
  function pieces(s) { var n = parseInt(String(s || '').replace(/\D/g, ''), 10); return isNaN(n) ? 0 : n; }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  var T = EN ? {
    per: 'net / pc', more: 'net more per pc', incl: 'included', of: 'of', left: 'still to assign', over: 'too many', pcs: 'pcs',
    ok: 'All assigned', gross: 'incl. VAT', open: 'Open now · until', soon: 'Opens on', closed: 'This door is closed',
    min: 'Minimum', next: 'more and you pay only', ea: 'per pc', best: 'Best team price reached',
    needSum: 'Please assign exactly', adding: 'Adding to cart …', added: 'Added. Opening cart …', err: 'That did not work. Please try again.',
    later: 'will follow by email after ordering'
  } : {
    per: 'netto / Stk.', more: 'netto mehr je Stk.', incl: 'inklusive', of: 'von', left: 'noch zu verteilen', over: 'zu viel', pcs: 'Stück',
    ok: 'Alles verteilt', gross: 'inkl. MwSt.', open: 'Jetzt geöffnet · bis', soon: 'Öffnet am', closed: 'Dieses Türchen ist geschlossen',
    min: 'Mindestens', next: 'mehr und du zahlst nur', ea: 'je Stück', best: 'Bester Teampreis erreicht',
    needSum: 'Bitte verteile genau', adding: 'Wird in den Warenkorb gelegt …', added: 'Liegt im Warenkorb. Weiter zum Warenkorb …', err: 'Das hat nicht geklappt. Bitte versuch es noch einmal.',
    later: 'folgt nach der Bestellung per E-Mail'
  };

  /* Zeitfenster in deutscher Zeit */
  var params = new URLSearchParams(location.search);
  function berlinDay() { try { return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Berlin' }).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); } }
  function fmt(d) { var p = d.split('-'); return EN ? (+p[2]) + '/' + (+p[1]) : (+p[2]) + '.' + (+p[1]) + '.'; }
  var today = berlinDay(), from = el.dataset.open || '', until = el.dataset.close || '';
  var force = params.get('spdeal') || ((window.Shopify && window.Shopify.designMode) ? 'open' : '');
  var phase = force || (!from ? 'open' : (today < from ? 'soon' : (until && today > until ? 'closed' : 'open')));
  var st = $('[data-spdl-status]');
  st.textContent = phase === 'open' ? (T.open + ' ' + (until ? fmt(until) + (EN ? ', 11:59 pm' : ', 23:59 Uhr') : '')) : (phase === 'soon' ? T.soon + ' ' + fmt(from) + (EN ? ', 0:00 am' : ', 0:00 Uhr') : T.closed);
  st.classList.add('is-' + phase);

  /* Auswahl */
  var opt1 = $$('[data-spdl-opt="1"] [data-spdl-val]'), opt2 = $$('[data-spdl-opt="2"] [data-spdl-val]');
  var sel = { o1: opt1[0] ? opt1[0].dataset.spdlVal : null, o2: opt2[0] ? opt2[0].dataset.spdlVal : null };
  function find(o1, o2) { for (var i = 0; i < variants.length; i++) { var v = variants[i]; if (v.o1 === o1 && v.o2 === o2) return v; } return null; }
  function current() { return find(sel.o1, sel.o2); }
  var qIn = $('[data-spdl-qty]'), qMsg = $('[data-spdl-qmsg]');
  var tiers = opt2.map(function (b) { return { el: b, val: b.dataset.spdlVal, n: pieces(b.dataset.spdlVal) }; }).sort(function (a, b) { return a.n - b.n; });
  var minQ = tiers.length ? tiers[0].n : 1;
  qIn.min = minQ; qIn.value = minQ;
  function need() { return Math.max(0, parseInt(qIn.value, 10) || 0); }
  function tierFor(n) { var t = tiers[0]; tiers.forEach(function (x) { if (n >= x.n) t = x; }); return t; }
  function nextTier(n) { for (var i = 0; i < tiers.length; i++) if (tiers[i].n > n) return tiers[i]; return null; }

  opt1.forEach(function (b) {
    b.addEventListener('click', function () {
      opt1.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      sel.o1 = b.dataset.spdlVal; update();
      if (el.dataset.mediaSwitch === '1') { var ti = opt1.indexOf(b); if (thumbs && thumbs[ti]) thumbs[ti].click(); }
    });
  });
  opt2.forEach(function (b) { b.addEventListener('click', function () { qIn.value = pieces(b.dataset.spdlVal); update(); }); });
  qIn.addEventListener('input', update);
  qIn.addEventListener('blur', function () { if (need() < minQ) { qIn.value = minQ; update(); } });
  $$('[data-spdl-step]').forEach(function (b) { b.addEventListener('click', function () { qIn.value = Math.max(minQ, need() + parseInt(b.dataset.spdlStep, 10)); update(); }); });

  /* Farben */
  var qty = {}, sq = {};
  function showColor(c) {
    if (!c.b) return;
    var ev = new CustomEvent('spdl:color', { detail: c, cancelable: true });
    if (!el.querySelector('[data-spdl-place]')) { var mm = el.querySelector('[data-spdl-main]'); if (mm) { mm.src = c.b; mm.removeAttribute('srcset'); mm.alt = c.n; } el.querySelectorAll('[data-spdl-thumb]').forEach(function (x) { x.classList.remove('is-on'); }); }
    el.dispatchEvent(ev);
  }
  var sizes = json('[data-spdl-sizes]').filter(function (s) { return s; });
  var box = $('[data-spdl-colors]');
  if (sizes.length) box.classList.add('is-sizes');
  colors.forEach(function (c) {
    if (sizes.length) {
      /* Farbe + Größen: Zeile aufklappen, je Größe eine Menge */
      var r = document.createElement('div');
      r.className = 'spdl__color spdl__color--sz'; r.dataset.name = c.n.toLowerCase();
      r.innerHTML = '<button type="button" class="spdl__chead" aria-expanded="false"><span class="spdl__sw">' + (c.i ? '<img src="' + c.i + '" alt="" loading="lazy" width="48" height="48">' : '') + '</span>' +
        '<span class="spdl__cn"></span><span class="spdl__csum">0</span></button><div class="spdl__sizes" hidden></div>';
      r.querySelector('.spdl__cn').textContent = c.n;
      var head = r.querySelector('.spdl__chead'), grid = r.querySelector('.spdl__sizes'), sum = r.querySelector('.spdl__csum');
      head.addEventListener('click', function () {
        showColor(c);
        var open = grid.hidden; grid.hidden = !open; head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var f = grid.querySelector('input'); if (f) f.focus(); }
      });
      sizes.forEach(function (s) {
        var cell = document.createElement('label');
        cell.className = 'spdl__sz';
        cell.innerHTML = '<span></span><input type="number" inputmode="numeric" min="0" step="1" placeholder="0">';
        cell.querySelector('span').textContent = s;
        var inp = cell.querySelector('input');
        inp.setAttribute('aria-label', c.n + ' ' + s + (EN ? ' quantity' : ' Menge'));
        inp.addEventListener('input', function () {
          var k = Math.max(0, parseInt(inp.value, 10) || 0);
          sq[c.n] = sq[c.n] || {};
          if (k) sq[c.n][s] = k; else delete sq[c.n][s];
          var tt = Object.keys(sq[c.n]).reduce(function (x, y) { return x + sq[c.n][y]; }, 0);
          if (tt) qty[c.n] = tt; else delete qty[c.n];
          sum.textContent = tt; r.classList.toggle('is-set', tt > 0); update();
        });
        grid.appendChild(cell);
      });
      box.appendChild(r);
      return;
    }
    var row = document.createElement('label');
    row.className = 'spdl__color'; row.dataset.name = c.n.toLowerCase();
    row.innerHTML = '<span class="spdl__sw">' + (c.i ? '<img src="' + c.i + '" alt="" loading="lazy" width="48" height="48">' : '') + '</span>' +
      '<span class="spdl__cn"></span><input type="number" inputmode="numeric" min="0" step="1" placeholder="0">';
    row.querySelector('.spdl__cn').textContent = c.n;
    var inp = row.querySelector('input');
    inp.setAttribute('aria-label', c.n + (EN ? ' quantity' : ' Menge'));
    inp.addEventListener('focus', function () { showColor(c); });
    inp.addEventListener('input', function () {
      var k = Math.max(0, parseInt(inp.value, 10) || 0);
      if (k) qty[c.n] = k; else delete qty[c.n];
      row.classList.toggle('is-set', k > 0); update();
    });
    box.appendChild(row);
  });
  var search = $('[data-spdl-search]');
  search.addEventListener('input', function () {
    var q = search.value.trim().toLowerCase();
    $$('.spdl__color').forEach(function (r) { r.hidden = q && r.dataset.name.indexOf(q) < 0 && !r.classList.contains('is-set'); });
  });
  function total() { return Object.keys(qty).reduce(function (s, k) { return s + qty[k]; }, 0); }

  /* Logo */
  var file = $('[data-spdl-file]'), later = $('[data-spdl-later]'), fname = $('[data-spdl-filename]');
  file.addEventListener('change', function () { if (file.files[0]) { fname.textContent = file.files[0].name; later.checked = false; } update(); });
  later.addEventListener('change', update);

  /* Zusammenfassung */
  var btn = $('[data-spdl-add]'), msg = $('[data-spdl-msg]');
  function update() {
    var n = need(), t = total(), tr = tierFor(n), ok = n >= minQ;
    if (tr) sel.o2 = tr.val;
    var v = current();
    /* Stickgröße: Zusatz je Stück */
    var base = find(opt1[0] && opt1[0].dataset.spdlVal, sel.o2);
    opt1.forEach(function (b, i) {
      var bv = find(b.dataset.spdlVal, sel.o2), s = b.querySelector('[data-spdl-sub]');
      if (!bv || !base || !s) return;
      var d = (bv.p - base.p) / VAT;
      s.textContent = i === 0 || d <= 0 ? T.incl : '+' + eur(d) + ' ' + T.more;
    });
    /* Staffel-Kacheln */
    tiers.forEach(function (x) {
      var tv = find(sel.o1, x.val), s = x.el.querySelector('[data-spdl-sub]');
      if (tv && s) s.innerHTML = eur(tv.p / VAT) + '<small>' + eur(tv.p) + ' ' + T.gross + '</small>';
      x.el.setAttribute('aria-pressed', ok && x === tr ? 'true' : 'false');
    });
    var nx = nextTier(n), nv = nx ? find(sel.o1, nx.val) : null;
    qMsg.className = 'spdl__qmsg' + (ok ? '' : ' is-warn');
    qMsg.textContent = !ok ? T.min + ' ' + minQ + ' ' + T.pcs + '.' : (nx && nv ? (EN ? 'Just ' : 'Nur noch ') + num(nx.n - n) + ' ' + T.pcs + ' ' + T.next + ' ' + eur(nv.p / VAT) + ' ' + T.ea + '.' : T.best + '.');
    /* Preis: netto = Stückpreis netto × Menge, brutto wie Shopify rechnet */
    var unet = v ? Math.round(v.p / VAT) : 0;
    $('[data-spdl-net]').textContent = v && n ? eur(v.p * n) : '–';
    var lbl = $('[data-spdl-net]').parentNode.querySelector('small'); if (lbl) lbl.textContent = EN ? 'incl. 19 % VAT' : 'inkl. 19 % MwSt.';
    $('[data-spdl-gross]').textContent = v && n ? eur(unet * n) + (EN ? ' net plus 19 % VAT ' : ' netto zzgl. 19 % MwSt. ') + eur(v.p * n - unet * n) + ' · ' + num(n) + ' × ' + eur(unet) + ' ' + T.per : '';
    /* Farben */
    var c = $('[data-spdl-count]');
    c.className = 'spdl__count' + (t === n && n ? ' is-ok' : (t > n ? ' is-over' : ''));
    c.textContent = (t === n && n ? '✓ ' + T.ok + ': ' : '') + num(t) + ' ' + T.of + ' ' + num(n) + ' ' + T.pcs +
      (t < n ? ' · ' + num(n - t) + ' ' + T.left : (t > n ? ' · ' + num(t - n) + ' ' + T.over : ''));
    var logoOk = later.checked || (file.files && file.files[0]);
    btn.disabled = !(phase === 'open' && v && v.a !== false && t === n && ok && logoOk);
  }

  btn.addEventListener('click', function () {
    var v = current(), n = need();
    if (!v || btn.disabled) return;
    if (total() !== n) { msg.textContent = T.needSum + ' ' + num(n) + ' ' + T.pcs + '.'; return; }
    var split = colors.filter(function (c) { return qty[c.n]; }).map(function (c) {
      if (!sizes.length) return c.n + ' ' + qty[c.n];
      return c.n + ' (' + sizes.filter(function (s) { return sq[c.n] && sq[c.n][s]; }).map(function (s) { return s + ' ' + sq[c.n][s]; }).join(', ') + ')';
    }).join(' · ');
    var props = {};
    props[sizes.length ? (EN ? 'Colours and sizes' : 'Farben und Größen') : (EN ? 'Colour split' : 'Farbaufteilung')] = split;
    props['_sp_adv'] = el.dataset.title;
    var note = $('[data-spdl-note]').value.trim().slice(0, 500);
    if (note) props['Dein Hinweis'] = note;
    var plo = $('[data-spdl-place-out]');
    if (plo && plo.value) props[EN ? 'Logo placement' : 'Logo-Platzierung'] = plo.value;
    var f = file.files && file.files[0];
    if (!f) props['1. Logo Datei'] = T.later;
    var fd = new FormData();
    fd.append('items[0][id]', v.id);
    fd.append('items[0][quantity]', n);
    Object.keys(props).forEach(function (k) { fd.append('items[0][properties][' + k + ']', props[k]); });
    if (f) fd.append('items[0][properties][1. Logo Datei]', f, f.name);
    btn.disabled = true; btn.classList.add('is-loading'); msg.textContent = T.adding;
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || r.status); return j; }); })
      .then(function () { msg.textContent = T.added; location.href = root() + 'cart'; })
      .catch(function (e) { msg.textContent = T.err + (e && e.message ? ' (' + e.message + ')' : ''); btn.classList.remove('is-loading'); update(); });
  });

  /* Galerie mit KI-Hinweis */
  var main = $('[data-spdl-main]'), badge = $('.spdl__main [data-sp-ai-badge]');
  var thumbs = $$('[data-spdl-thumb]');
  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      if (main) { main.src = b.dataset.spdlThumb; main.removeAttribute('srcset'); main.alt = b.dataset.alt || ''; }
      thumbs.forEach(function (x) { x.classList.toggle('is-on', x === b); });
      if (badge) {
        var ai = b.dataset.ai;
        badge.hidden = !ai;
        var tx = badge.querySelector('[data-sp-ai-text]');
        if (ai && tx) tx.textContent = ai === 'edited' ? badge.dataset.textEdited : badge.dataset.textGenerated;
      }
    });
  });

  update();
})();
